export default class CNPJ {
  static tamanhoCNPJSemDV = 12;
  static regexCNPJ = /^([A-Z\d]){12}(\d){2}$/;
  static pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  static isValid(cnpj) {
    if (!cnpj) return false;
    let cnpjSemMascara = cnpj.replace(/[./-]/g, '').toUpperCase();

    if (this.regexCNPJ.test(cnpjSemMascara)) {
      const dvInformado = cnpjSemMascara.substring(this.tamanhoCNPJSemDV);
      const dvCalculado = this.calculaDV(cnpjSemMascara.substring(0, this.tamanhoCNPJSemDV));
      return dvInformado === dvCalculado;
    }
    return false;
  }

  static calculaDV(cnpjBase) {
    let somatorioDV1 = 0
    let somatorioDV2 = 0

    for (let i = 0; i < this.tamanhoCNPJSemDV; i++) {
      const valor = cnpjBase.charCodeAt(i) - 48; // Lógica NT 01/2023

      somatorioDV1 += valor * this.pesosDV[i + 1]
      somatorioDV2 += valor * this.pesosDV[i]
    }

    const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11)
    somatorioDV2 += dv1 * this.pesosDV[this.tamanhoCNPJSemDV]
    const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11)

    return `${dv1}${dv2}`;
  }
}
